import { handleError } from '@anchorage/sentry';

export const formatValueForDisplay = (value: string): string => {
  if (!value || Number.isNaN(Number(value))) {
    return '';
  }

  const isNegative = value.startsWith('-');
  // Must turn this value absolute because of '-0'
  const absValue = value.replace('-', '');
  const [main, dec] = absValue.split('.');

  try {
    // BigInt is used to be able to handle big values
    // Incorrect type for BigInt.toLocaleString
    const formattedValue = BigInt(main as string).toLocaleString('en-US');
    const hasDecimal = dec !== undefined;

    return `${isNegative ? '-' : ''}${formattedValue}${
      hasDecimal ? `.${dec}` : ''
    }`;
  } catch (error) {
    handleError(
      new Error(
        `Error parsing ${main} to BigInt type: ${(error as Error)?.message}`,
      ),
    );

    return '';
  }
};
